"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServusTVLiveVideo1Schema = void 0;
exports.ServusTVLiveVideo1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/servus-tv-livevideo/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ServusTVLiveVideo1",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:servus-tv-livevideo:1"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "videoId": {
                    "type": "string",
                    "description": "Asset ID from MIT mediabase asset catalogue (e.g. AA-1UPS7JDND1W12)",
                    "pattern": "^([0-9]+-[0-9]+|AA-[A-Z0-9]{13}|AA[A-Z|0-9]{18})$"
                },
                "videoSrc": {
                    "type": "string",
                    "description": "Video source system"
                }
            },
            "required": [
                "videoId",
                "videoSrc"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9zZXJ2dXMtdHYtbGl2ZXZpZGVvLzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsd0JBQXdCLEdBQUc7SUFDdEMsS0FBSyxFQUFFLHdGQUF3RjtJQUMvRixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxvQkFBb0I7SUFDN0IsTUFBTSxFQUFFLFFBQVE7SUFDaEIsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLGdEQUFnRDthQUNqRDtTQUNGO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsc0JBQXNCLEVBQUUsS0FBSztZQUM3QixZQUFZLEVBQUU7Z0JBQ1osU0FBUyxFQUFFO29CQUNULE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUscUVBQXFFO29CQUNwRixTQUFTLEVBQUUsbURBQW1EO2lCQUMvRDtnQkFDRCxVQUFVLEVBQUU7b0JBQ1YsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSxxQkFBcUI7aUJBQ3JDO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsU0FBUztnQkFDVCxVQUFVO2FBQ1g7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsWUFBWTtRQUNaLE1BQU07S0FDUDtDQUNGLENBQUEifQ==